export const AccountTypeFunding = [
  'individual',
  'joint'
];
